import React from "react";
import Addgame from "../components/addgame";
export function AddgamePage() {
  return <Addgame />;
}
export default AddgamePage;
